<template>
	<div :class="{'container-fluid': !isSettingsComponent}">
		<settings-toolbar v-if="!isSettingsComponent" title="Permission Templates" icon="fa-lock" :show-new-button="true" v-on:newButtonClick="newTemplate"></settings-toolbar>
		<h3 v-else>Permission Templates</h3>

		<div class="row">
			<div class="col-md-4">
				<table-list
					record-name="Permission Template"
					:hide-record-count="true"
					:records="templates"
					:fields="fields"
					:has-edit="true"
					:has-delete="true"
					delete-endpoint="PermissionTemplate/delete"
					v-on:edit="editTemplate"
					v-on:modelChange="fetchData">

					<button class="btn btn-success" v-on:click="newTemplate">
						<i class="fa fa-plus"></i>
						New Template
					</button>

				</table-list>
			</div>
			<div class="col-md-8">
				<div v-if="selectedTemplateId > 0 || creatingNewTemplate" >

					<field v-model="title" v-on:change="save" label="Template Name" col-class="col-md-5 col-lg-4" ></field>

					<module-permssion-control 
						v-for="module in modules" 
						:module-name="module"
						:module-permissions="modulePermissions"
						:key="module"
						v-on:permsChanged="save">
					</module-permssion-control>

				</div>
				<div v-else>
					<p>No template selected</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import ModulePermssionControl from "../../components/ModulePermssionControl"
import SettingsToolbar from "./SettingsToolbar"
import TableList from "../../components/TableList"
import Field from "../../components/Field"

export default {

	name: 'PermissionTemplates',
	components: {
		SettingsToolbar,
		TableList,
		ModulePermssionControl,
		Field
	},
	props: ["isSettingsComponent"],
	data() {
		return {
			templates: [],
			fields: [
				{label: "Title",key: "title"}
			],
			modules: [],
			selectedTemplateId: null,
			modulePermissions: {},
			title: "",
			creatingNewTemplate: false
		}
	},
	methods: {
		editTemplate(record) {
			this.selectedTemplateId = record.id
			this.title = record.title
			this.modulePermissions = JSON.parse(record.module_permissions)
			this.creatingNewTemplate = false
		},
		newTemplate() {
			this.title = ""
			this.createModulePermsObj(this.modules)
			this.creatingNewTemplate = true
			this.selectedTemplateId = false
		},
		updatePerms(newPerms) {

		},
		save() {
			let vm = this

			let payload = {
				title: this.title,
				module_permissions: JSON.stringify(this.modulePermissions)
			}

			if (this.selectedTemplateId > 0)
				payload.id = this.selectedTemplateId

			this.saveRecord("PermissionTemplate",payload, response => {
				if (!("id" in payload)) {
					//this was a new record, so we need to assign it now
					vm.selectedTemplateId = response.record_id
					vm.creatingNewTemplate = false
				}

				vm.fetchData()
			})
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			Promise.all([
				this.getJSON("PermissionTemplate/get"),
				this.getJSON("Module/get")
			]).then(function(responses){

				vm.templates = responses[0].data

				vm.modules = responses[1].data

				vm.createModulePermsObj(vm.modules)

				vm.spinner(false)

			})

		},
		createModulePermsObj(modules) {
			let vm = this

			modules.forEach((mod,index) => {
				//loop through each module and check if it exists in the module permissions object yet, if not, add with read/write as false



				if (!(mod in vm.modulePermissions)) {

					vm.$set(vm.modulePermissions,mod,{
						read: false,
						write: false
					})
				}
			})

		}
	},
	created() {
		this.fetchData()
	}

}
</script>